import { ErrorBoundary } from 'react-error-boundary';
import { MemoryRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { trackError } from 'utils/helpers';
import ExpiryBookingCheck from 'components/expiry_booking_check';
import { bookingFormFallbackRender } from '../error_boundary';
import Experience from './experience';

const ExperienceRouter = ({
  noExpiryCheck,
  productPrice,
  productSalePrice,
}) => (
  <MemoryRouter>
    <ErrorBoundary
      fallbackRender={bookingFormFallbackRender}
      onError={trackError}
    >
      <Experience
        productPrice={productPrice}
        productSalePrice={productSalePrice}
      />
    </ErrorBoundary>
    {!noExpiryCheck && (
      <ExpiryBookingCheck reload id="experience-expiry-check" />
    )}
  </MemoryRouter>
);

ExperienceRouter.propTypes = {
  noExpiryCheck: PropTypes.bool,
  productPrice: PropTypes.number,
  productSalePrice: PropTypes.number,
};

export default ExperienceRouter;
